import React from "react";
import PropTypes from "prop-types";
import { Provider } from "rebass";

import { theme, injectGlobalStyles } from "./styles";
import SEO from "./SEO";
import Header from "./Header";
import Main from "./Main";
import Footer from "./Footer";

injectGlobalStyles();

const Layout = ({
  children,
  title,
  shortTitle,
  copyright,
  description,
  keywords
}) => (
  <Provider theme={theme}>
    <SEO
      title={title}
      description={description}
      keywords={keywords}
      shortTitle={shortTitle}
    />
    <Header title={shortTitle} />
    <Main>{children}</Main>
    <Footer copyright={copyright} />
  </Provider>
);

Layout.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  shortTitle: PropTypes.string,
  copyright: PropTypes.string,
  description: PropTypes.string,
  keywords: PropTypes.string
};

Layout.defaultProps = {
  title: `Site Title`,
  shortTitle: `Title`,
  copyright: `Copyright`,
  description: `Description`
};

export default Layout;



// WEBPACK FOOTER //
// ./src/containers/Layout/Layout.js